<div *ngIf="blueLimitReached" class="blueLimitContainer">
  <div class="blueFlexContainer">
    <p>
      You've reached your maximum number of free recordings as a blue member!
      Upgrade to GOLD now for unlimited recording!
    </p>
    <button (click)="purchaseGold()">Purchase GOLD</button>
    <button (click)="backClicked()">Go Back</button>
  </div>
</div>

<main id="recorder" class="shell" #recorderContainer [ngStyle]="storeFillLightStyle" [class.fill-light-active]="recorderStore.fillLight().brightness > 0" [class.is-fullscreen]="fullscreen">

  <!-- ── Loading screen ── -->
  <div id="loading" *ngIf="!loaded" role="status" aria-label="Loading recorder">
    <div
      id="singsnapContainer"
      style="padding-right: 2.5rem; display: flex; flex-direction: row; align-items: center; justify-content: center;"
    >
      <img src="../../assets/images/recorderlogo.png" alt="SingSnap" />
      <h2>SINGSNAP</h2>
    </div>
    <div class="vl"></div>
    <h2 class="recording-loading">
      Loading...
      <i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 47px; text-shadow: none" aria-hidden="true"></i>
    </h2>
  </div>

  <!-- ── HEADER: back button + title + stage stepper + controls ── -->
  <header class="shell__header" *ngIf="loaded">
    <div class="rec-header">
      <div class="rec-header__inner">

        <div class="rec-header__left">
          <button class="rec-back-btn" *ngIf="!finished" (click)="backClicked()" aria-label="Back">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <div class="rec-header__meta">
            <h2 class="rec-header__title" (mousedown)="toAdmin(song.id)">{{ title }}</h2>
            <p class="rec-header__artist" *ngIf="part">{{ part }}</p>
          </div>
        </div>

        <div class="rec-header__center">
          <rec-stage-stepper
            [recState]="recorderStore.recState()"
            [setupComplete]="recorderStore.setupComplete()"
            [mode]="recorderStore.mode()"
          ></rec-stage-stepper>
        </div>

        <div class="rec-header__right">
          <button type="button" class="rec-header__others"
                  (click)="onOtherSingers()"
                  ssTooltip="Listen to how other singers have performed this song">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
              <path d="M21 19a2 2 0 0 1-2 2h-1v-7h3v5zM3 19a2 2 0 0 0 2 2h1v-7H3v5z"/>
            </svg>
            <span>Listen to others sing this</span>
          </button>
        </div>

      </div>
    </div>
  </header>

  <!-- ── MAIN 3-COLUMN GRID ── always rendered so video elements exist for recorder init ── -->
  <div class="shell__grid" #topUI id="topUI">

    <!-- ── Fullscreen floating panel toggle buttons ── -->
    <button *ngIf="fullscreen && !fsPanelLeftOpen" class="fs-panel-btn fs-panel-btn--left" type="button"
            (click)="toggleFsPanelLeft()"
            [attr.aria-label]="fsPanelLeftOpen ? 'Close setup panel' : 'Open setup panel'"
            ssTooltip="Open record setup">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/><circle cx="8" cy="6" r="2" fill="currentColor" stroke="none"/><circle cx="16" cy="12" r="2" fill="currentColor" stroke="none"/><circle cx="10" cy="18" r="2" fill="currentColor" stroke="none"/></svg>
    </button>
    <button *ngIf="fullscreen && !fsPanelRightOpen" class="fs-panel-btn fs-panel-btn--right" type="button"
            (click)="toggleFsPanelRight()"
            [attr.aria-label]="fsPanelRightOpen ? 'Close visual panel' : 'Open visual panel'"
            ssTooltip="Open visual setup">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08"/><path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z"/></svg>
    </button>

    <!-- LEFT panel -->
    <aside class="shell__panel shell__panel--left" [class.fs-open]="fsPanelLeftOpen" *ngIf="loaded && (!finished || UIState === 'review' || UIState === 'reviewPaused')">
      <button class="fs-panel-close" type="button" (click)="closeFsPanelLeft()" aria-label="Close panel"
              [attr.tabindex]="(fullscreen && fsPanelLeftOpen) ? null : -1">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      <!-- ── SETUP / RECORDING / PRACTICE panel ── -->
      <div class="panel" *ngIf="UIState !== 'review' && UIState !== 'reviewPaused'">
        <div class="panel__header panel__header--static">
          <span class="panel__title">Recording Setup</span>
          <span class="panel__status panel__status--ready" *ngIf="UIState === 'default' || UIState === 'countdown'">
            <span class="panel__status-dot"></span> Ready
          </span>
        </div>
        <div class="panel__body">

          <!-- Devices section -->
          <div class="section" *ngIf="UI.cameraButton || UI.micButton || UIState === 'recording' || UIState === 'countdown'">
            <h3 class="section__header">
              <span class="section__label">Devices</span>
              <span class="section__locked" *ngIf="UIState === 'recording' || UIState === 'countdown'">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                Locked
              </span>
            </h3>
            <div class="section__body">
              <div class="device-dropdowns">

                <!-- CAMERA -->
                <div class="device-inline-wrap" *ngIf="UI.cameraButton">
                  <button
                    #camTriggerBtn
                    class="device-trigger device-trigger--cam"
                    [class.is-open]="videoDropDown"
                    (click)="$event.stopPropagation(); toggleVideoDropDown()"
                    (keydown)="onCamTriggerKeydown($event)"
                    type="button"
                    [attr.aria-expanded]="videoDropDown"
                    aria-controls="cam-listbox"
                    aria-label="Select camera"
                    ssTooltip="Choose the camera you want to use for this recording">
                    <span class="device-trigger__icon">
                      <app-icon-camera color="currentColor" [size]="14"></app-icon-camera>
                    </span>
                    <span class="device-trigger__name">{{ selectedCamLabel }}</span>
                    <svg class="device-trigger__chevron" [class.is-open]="videoDropDown" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </button>
                  <div id="cam-listbox" class="device-inline-list" *ngIf="videoDropDown"
                       role="listbox" aria-label="Camera devices"
                       (click)="$event.stopPropagation()"
                       (keydown)="onCamListKeydown($event)">
                    <div class="device-inline-header">Select Camera</div>
                    <div
                      class="device-inline-item"
                      *ngFor="let cam of sources.video"
                      [class.is-active]="isActiveCam(cam.deviceId)"
                      (click)="changeCamSource(cam.deviceId); videoDropDown = false"
                      role="option"
                      tabindex="-1"
                      [attr.aria-selected]="isActiveCam(cam.deviceId)">
                      <span>{{ cam.label | deviceLabel }}</span>
                    </div>
                    <div
                      class="device-inline-item"
                      [class.is-active]="!cam"
                      (click)="toggleCamera(); videoDropDown = false"
                      role="option"
                      tabindex="-1"
                      [attr.aria-selected]="!cam">
                      <span>Camera off</span>
                    </div>
                  </div>
                </div>

                <!-- MIC -->
                <div class="device-inline-wrap" *ngIf="UI.micButton || UIState === 'recording' || UIState === 'countdown'">
                  <button
                    *ngIf="UI.micButton"
                    #micTriggerBtn
                    class="device-trigger device-trigger--mic"
                    [class.is-open]="micDropDown"
                    (click)="$event.stopPropagation(); toggleMicDropDown()"
                    (keydown)="onMicTriggerKeydown($event)"
                    type="button"
                    [attr.aria-expanded]="micDropDown"
                    aria-controls="mic-listbox"
                    aria-label="Select microphone"
                    ssTooltip="Choose the microphone you want to record with">
                    <span class="device-trigger__icon">
                      <app-icon-mic color="currentColor" [size]="14"></app-icon-mic>
                    </span>
                    <span class="device-trigger__name">{{ selectedMicLabel }}</span>
                    <svg class="device-trigger__chevron" [class.is-open]="micDropDown" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </button>
                  <div id="mic-listbox" class="device-inline-list" *ngIf="micDropDown && UI.micButton"
                       role="listbox" aria-label="Microphone devices"
                       (click)="$event.stopPropagation()"
                       (keydown)="onMicListKeydown($event)">
                    <div class="device-inline-header">Select Microphone</div>
                    <div
                      class="device-inline-item"
                      *ngFor="let mic of sources.audio"
                      [class.is-active]="isActiveMic(mic.deviceId)"
                      (click)="changeMicSource(mic.deviceId); micDropDown = false"
                      role="option"
                      tabindex="-1"
                      [attr.aria-selected]="isActiveMic(mic.deviceId)">
                      <span>{{ mic.label | deviceLabel }}</span>
                    </div>
                  </div>
                </div>

              </div><!-- /device-dropdowns -->

              <!-- Mirror video On/Off toggle -->
              <button
                *ngIf="UI.cameraButton && cam"
                type="button"
                class="mmsb-toggle mmsb-toggle--compact"
                [class.is-on]="videoFlip"
                [attr.aria-pressed]="videoFlip"
                ssTooltip="Mirror video — flips your camera horizontally. Baked into the recording."
                (click)="toggleFlip()"
              >
                <span class="mmsb-toggle__icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <line x1="12" y1="3" x2="12" y2="21"/>
                    <polyline points="8 8 4 12 8 16"/>
                    <polyline points="16 8 20 12 16 16"/>
                  </svg>
                </span>
                <span class="mmsb-toggle__text">Mirror</span>
                <span class="mmsb-toggle__badge" [class.is-on]="videoFlip">{{ videoFlip ? 'ON' : 'OFF' }}</span>
              </button>
            </div>
          </div><!-- /Devices section -->

          <!-- Audio section -->
          <div class="section" *ngIf="UI.micButton || UIState === 'recording' || UIState === 'countdown'">
            <h3 class="section__header">
              <span class="section__label">Audio</span>
              <span class="section__locked" *ngIf="UIState === 'recording' || UIState === 'countdown'">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                Locked
              </span>
            </h3>
            <div class="section__body">
              <!-- Live mic input level meter (relocated here from Devices — the engine
                   moves the #micMeter canvas into #mic-meter-slot via moveMicMeter) -->
              <div id="mic-meter-slot" class="device-mic-meter" [style.display]="finished ? 'none' : null"></div>
              <div class="mic-level-marks" [style.display]="finished ? 'none' : null" aria-hidden="true">
                <span class="mic-level-marks__tick" style="left:35%"></span>
                <span class="mic-level-marks__tick mic-level-marks__tick--warn" style="left:75%"></span>
                <span class="mic-level-marks__label" style="left:0">Low</span>
                <span class="mic-level-marks__label mic-level-marks__label--good" style="left:35%">Good</span>
                <span class="mic-level-marks__label mic-level-marks__label--loud" style="left:75%">Loud</span>
              </div>
              <rec-auto-mic-gain *ngIf="UI.micButton"></rec-auto-mic-gain>
              <div class="section__locked-placeholder" *ngIf="(UIState === 'recording' || UIState === 'countdown') && !UI.micButton">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                Auto Mic Gain
              </div>
            </div>
          </div>

          <!-- Performance section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Performance</span></h3>
            <div class="section__body">

              <!-- Volume slider -->
              <div class="perf-slider" [class.is-disabled]="!UI.volumeButton" ssTooltip="Adjust the backing track volume">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>
                    VOLUME
                  </span>
                  <span
                    *ngIf="editingPill !== 'music'"
                    class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                    role="button"
                    tabindex="0"
                    ssTooltip="Click to enter an exact value (0–100)"
                    (click)="startPillEdit('music', musicVolumeDisplay)"
                    (keydown.enter)="startPillEdit('music', musicVolumeDisplay)">{{ musicVolumeDisplay }}</span>
                  <input
                    *ngIf="editingPill === 'music'"
                    #pillInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="0" max="100" step="1"
                    aria-label="Music volume (0 to 100)"
                    [value]="pillDraft"
                    (blur)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                    (keydown.enter)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                    (keydown.escape)="cancelPillEdit()"
                  />
                </div>
                <input
                  type="range"
                  class="perf-slider__track"
                  min="0" max="2" step="0.02"
                  aria-label="Music volume"
                  [value]="musicVolume"
                  [disabled]="!UI.volumeButton"
                  [style.background]="sliderBg(musicVolume, 0, 2)"
                  (input)="onInlineTickVolumeChange(+$any($event.target).value)"
                />
                <div class="perf-slider__marks">
                  <span>0</span><span>50</span><span>100</span>
                </div>
              </div>

              <!-- Pitch slider -->
              <div class="perf-slider" [class.is-disabled]="!UI.pitchButton || !!jam" ssTooltip="Raise or lower the song key before recording">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="21" y1="4" x2="14" y2="4"/><line x1="10" y1="4" x2="3" y2="4"/><circle cx="12" cy="4" r="2"/><line x1="21" y1="12" x2="12" y2="12"/><line x1="8" y1="12" x2="3" y2="12"/><circle cx="10" cy="12" r="2"/><line x1="21" y1="20" x2="16" y2="20"/><line x1="12" y1="20" x2="3" y2="20"/><circle cx="14" cy="20" r="2"/></svg>
                    PITCH
                  </span>
                  <span
                    *ngIf="editingPill !== 'pitch'"
                    class="perf-slider__current perf-slider__current--pill"
                    [class.perf-slider__current--editable]="canEditPitch"
                    [attr.role]="canEditPitch ? 'button' : null"
                    [attr.tabindex]="canEditPitch ? 0 : null"
                    [ssTooltip]="canEditPitch ? 'Click to enter an exact value (-6 to +6)' : ''"
                    (click)="canEditPitch && startPillEdit('pitch', pitch)"
                    (keydown.enter)="canEditPitch && startPillEdit('pitch', pitch)">{{ pitch > 0 ? '+' : '' }}{{ pitch }}</span>
                  <input
                    *ngIf="editingPill === 'pitch'"
                    #pillInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="-6" max="6" step="1"
                    aria-label="Pitch in semitones (-6 to 6)"
                    [value]="pillDraft"
                    (blur)="commitPillEdit('pitch', $any($event.target).value, -6, 6)"
                    (keydown.enter)="commitPillEdit('pitch', $any($event.target).value, -6, 6)"
                    (keydown.escape)="cancelPillEdit()"
                  />
                </div>
                <input
                  type="range"
                  class="perf-slider__track"
                  min="-6" max="6" step="1"
                  aria-label="Pitch"
                  [value]="pitch"
                  [disabled]="!UI.pitchButton || !!jam"
                  [style.background]="sliderBg(pitch, -6, 6)"
                  (input)="onInlineTickPitchChange(+$any($event.target).value)"
                />
                <div class="perf-slider__marks">
                  <span>-6</span><span>0</span><span>+6</span>
                </div>
              </div>

            </div>
          </div>

        </div><!-- /panel__body -->
      </div><!-- /setup panel -->

      <!-- ── PLAYBACK / REVIEW panel ── -->
      <div class="panel" *ngIf="UIState === 'review' || UIState === 'reviewPaused'">
        <div class="panel__header panel__header--static">
          <span class="panel__title">Playback</span>
          <span class="panel__status panel__status--review">
            <span class="panel__status-dot panel__status-dot--review"></span> Review
          </span>
        </div>
        <div class="panel__body">

          <!-- MIX section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Mix</span></h3>
            <div class="section__body">

              <!-- Vocal Volume -->
              <div class="perf-slider" ssTooltip="Adjust the volume of your recorded voice">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                    Vocal Volume
                  </span>
                  <span
                    *ngIf="editingPill !== 'vocal'"
                    class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                    role="button"
                    tabindex="0"
                    ssTooltip="Click to enter an exact value (0–100)"
                    (click)="startPillEdit('vocal', micVolumeDisplay)"
                    (keydown.enter)="startPillEdit('vocal', micVolumeDisplay)">{{ micVolumeDisplay }}</span>
                  <input
                    *ngIf="editingPill === 'vocal'"
                    #pillInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="0" max="100" step="1"
                    aria-label="Vocal volume (0 to 100)"
                    [value]="pillDraft"
                    (blur)="commitPillEdit('vocal', $any($event.target).value, 0, 100)"
                    (keydown.enter)="commitPillEdit('vocal', $any($event.target).value, 0, 100)"
                    (keydown.escape)="cancelPillEdit()"
                  />
                </div>
                <input
                  type="range"
                  class="perf-slider__track"
                  min="0" max="2" step="0.02"
                  aria-label="Vocal volume"
                  [value]="micVolume"
                  [style.background]="sliderBg(micVolume, 0, 2)"
                  (input)="onMicVolumeSliderChange(+$any($event.target).value)"
                />
                <div class="perf-slider__marks">
                  <span>0</span><span>50</span><span>100</span>
                </div>
              </div>

              <!-- Music Volume -->
              <div class="perf-slider" ssTooltip="Adjust the backing track volume during playback">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>
                    Music Volume
                  </span>
                  <span
                    *ngIf="editingPill !== 'music'"
                    class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                    role="button"
                    tabindex="0"
                    ssTooltip="Click to enter an exact value (0–100)"
                    (click)="startPillEdit('music', musicVolumeDisplay)"
                    (keydown.enter)="startPillEdit('music', musicVolumeDisplay)">{{ musicVolumeDisplay }}</span>
                  <input
                    *ngIf="editingPill === 'music'"
                    #pillInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="0" max="100" step="1"
                    aria-label="Music volume (0 to 100)"
                    [value]="pillDraft"
                    (blur)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                    (keydown.enter)="commitPillEdit('music', $any($event.target).value, 0, 100)"
                    (keydown.escape)="cancelPillEdit()"
                  />
                </div>
                <input
                  type="range"
                  class="perf-slider__track"
                  min="0" max="2" step="0.02"
                  aria-label="Music volume"
                  [value]="musicVolume"
                  [style.background]="sliderBg(musicVolume, 0, 2)"
                  (input)="onInlineTickVolumeChange(+$any($event.target).value)"
                />
                <div class="perf-slider__marks">
                  <span>0</span><span>50</span><span>100</span>
                </div>
              </div>

              <!-- MMSB toggle -->
              <button
                *ngIf="UI.mmsbButton"
                type="button"
                class="mmsb-toggle"
                [class.is-on]="mmsb"
                [attr.aria-pressed]="mmsb"
                ssTooltip="Make Me Sound Better — enhances your voice in the mix"
                (click)="mmsb = !mmsb; onChangeMMSB()"
              >
                <span class="mmsb-toggle__icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M9 18V5l12-2v13"/>
                    <circle cx="6" cy="18" r="3"/>
                    <circle cx="18" cy="16" r="3"/>
                  </svg>
                </span>
                <span class="mmsb-toggle__text">Make Me Sound Better</span>
                <span class="mmsb-toggle__badge" [class.is-on]="mmsb">{{ mmsb ? 'ON' : 'OFF' }}</span>
              </button>

            </div>
          </div>

          <!-- TIMING section -->
          <div class="section" *ngIf="UI.syncButton">
            <h3 class="section__header"><span class="section__label">Timing</span></h3>
            <div class="section__body">

              <!-- Sync slider -->
              <div class="perf-slider" ssTooltip="Adjust the timing between your voice and the music">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>
                    Sync
                  </span>
                  <span
                    *ngIf="!syncEditing"
                    class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                    role="button"
                    tabindex="0"
                    ssTooltip="Click to enter an exact sync value"
                    (click)="startSyncEdit()"
                    (keydown.enter)="startSyncEdit()">{{ sync }} ms</span>
                  <input
                    *ngIf="syncEditing"
                    #syncInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="-500" max="500" step="1"
                    aria-label="Sync value in milliseconds"
                    [value]="syncDraft"
                    (blur)="commitSyncEdit($any($event.target).value)"
                    (keydown.enter)="commitSyncEdit($any($event.target).value)"
                    (keydown.escape)="cancelSyncEdit()"
                  />
                </div>
                <div class="sync-nudge">
                  <button
                    type="button"
                    class="sync-nudge__btn"
                    aria-label="Nudge sync earlier"
                    ssTooltip="−1 ms (hold to repeat by 5)"
                    (pointerdown)="startSyncNudge(-1)"
                    (pointerup)="stopSyncNudge()"
                    (pointerleave)="stopSyncNudge()"
                    (pointercancel)="stopSyncNudge()"
                    (keydown.enter)="nudgeSync(-1); $event.preventDefault()">−</button>
                  <input
                    type="range"
                    class="perf-slider__track"
                    min="-500" max="500" step="10"
                    aria-label="Sync offset in milliseconds"
                    [value]="sync"
                    [style.background]="sliderBg(sync, -500, 500)"
                    (input)="onSyncSliderInput(+$any($event.target).value)"
                    (change)="onSyncSliderChange(+$any($event.target).value)"
                  />
                  <button
                    type="button"
                    class="sync-nudge__btn"
                    aria-label="Nudge sync later"
                    ssTooltip="+1 ms (hold to repeat by 5)"
                    (pointerdown)="startSyncNudge(1)"
                    (pointerup)="stopSyncNudge()"
                    (pointerleave)="stopSyncNudge()"
                    (pointercancel)="stopSyncNudge()"
                    (keydown.enter)="nudgeSync(1); $event.preventDefault()">+</button>
                </div>
                <div class="perf-slider__marks">
                  <span>-500ms</span><span>0ms</span><span>500ms</span>
                </div>
              </div>

              <!-- Auto Sync card -->
              <div class="auto-sync-card">
                <div class="auto-sync-card__top">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <span class="auto-sync-card__title">Auto Sync</span>
                </div>
                <p class="auto-sync-card__desc">Automatically measure audio delay.</p>
                <button class="auto-sync-card__btn" type="button" (click)="onSyncTestClick()" ssTooltip="Automatically measure and suggest the best sync value">
                  Auto Calculate Sync
                </button>
              </div>

            </div>
          </div>

        </div><!-- /panel__body -->
      </div><!-- /playback panel -->

    </aside><!-- /left panel -->

    <!-- CENTER: video stage -->
    <div class="shell__stage" role="region" aria-label="Video stage">
      <section id="videoSection" aria-label="Video preview" [class.is-duet-section]="jam">
        <div #countdown style="display: none" class="countdown" aria-live="assertive" aria-atomic="true">
          <h2>{{ count }}</h2>
        </div>
        <div
          #errorMessageContainer
          style="display: none; color: red; text-align: center"
          class="countdown"
          role="alert"
        >
          <h3 #errorMessage></h3>
        </div>
        <div id="lyrics-container" [style.visibility]="loaded && lyricsVisible ? 'visible' : 'hidden'" aria-hidden="true">
          <div id="grave" class="hidden"></div>
          <div id="lines-container">
            <div id="the-grave" class="lyrics"></div>
            <div id="swipe" class="lyrics"></div>
            <div id="next-up" class="lyrics"></div>
            <div id="initial" class="lyrics"></div>
            <div id="the-womb" class="lyrics"></div>
          </div>
          <div id="womb" class="hidden"></div>
        </div>
        <div class="parts__selector" *ngIf="partSelector">
          <h3>SELECT A PART TO SING:</h3>
          <p
            *ngFor="let part of parts | keyvalue"
            class="duet__part selectable"
            (click)="selectPart(part.key)"
          >
            <span [style.color]="part.value">{{ part.key }}</span>
          </p>
          <p class="both-part">
            LYRICS WHEN <span style="color: Green">BOTH</span> PEOPLE SING WILL SHOW IN Green
          </p>
        </div>
        <div id="videoContainer" [class.is-duet]="jam" [class.is-recording]="UIState === 'recording' || UIState === 'countdown'">
          <button
            *ngIf="loaded"
            type="button"
            class="video-fs-btn"
            [hidden]="fullscreen && fsPanelRightOpen"
            (click)="toggleFullscreen()"
            [attr.aria-label]="fullscreen ? 'Exit fullscreen' : 'Enter fullscreen'"
            [ssTooltip]="fullscreen ? 'Return to the standard recorder view' : 'Expand the recorder for a larger performance view'"
          >
            <svg *ngIf="!fullscreen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/>
              <line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/>
            </svg>
            <svg *ngIf="fullscreen" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/>
              <line x1="10" y1="14" x2="3" y2="21"/><line x1="21" y1="3" x2="14" y2="10"/>
            </svg>
          </button>
          <p id="version" aria-hidden="true">{{ version }}</p>
          <!-- In-video state badge -->
          <div class="stage-badge stage-badge--recording" *ngIf="UIState === 'recording'">
            <span class="stage-badge__dot" aria-hidden="true"></span>
            Recording
          </div>
          <div class="stage-badge stage-badge--review" *ngIf="UIState === 'review' || UIState === 'reviewPaused'">
            <span class="stage-badge__dot" aria-hidden="true"></span>
            <span class="stage-badge__label">REVIEW</span>
          </div>
          <div class="stage-badge stage-badge--practice"
               [class.stage-badge--practice-paused]="UIState === 'practicingPaused'"
               *ngIf="UIState === 'practicing' || UIState === 'practicingPaused'"
               ssTooltip="You are rehearsing. No recording is being saved.">
            <span class="stage-badge__dot" aria-hidden="true"></span>
            <span class="stage-badge__label">PRACTICE</span>
          </div>
          <div id="actualVideoContainer">
            <canvas
              #filterCanvas
              crossOrigin="anonymous"
              [hidden]="!filters"
              id="filters"
              height="600"
              width="600"
            ></canvas>
            <video
              #recVideo
              crossOrigin="anonymous"
              id="videoRecorder"
              autoplay="true"
              style="background-image: url(../../assets/images/audio_only.png); background-position: center; background-repeat: no-repeat; background-size: contain; width: 100%; height: 100%; object-fit: cover; opacity: 0;"
            ></video>
            <img
              class="no-cam-overlay"
              src="../../assets/images/audio_only.png"
              [hidden]="cam"
              alt=""
              aria-hidden="true"
            />
            <video
              #duetVideo
              style="display: none; width: 100%; height: 100%; object-fit: cover; background-image: url(../../assets/images/audio_only.png); background-position: center; background-repeat: no-repeat; background-size: contain;"
              id="duetVideo"
              autoplay="false"
            ></video>
          </div>
          <!-- mic meter canvas required by SSRecorder — do not remove; moved to mic slot via initDom -->
          <canvas id="micMeter" width="4" height="550" style="position:absolute;width:1px;height:1px;opacity:0;pointer-events:none"></canvas>
          <!-- ── Fullscreen action overlay ── -->
          <div class="fs-action-bar" *ngIf="fullscreen && loaded">

            <!-- default / countdown: Record + Practice -->
            <ng-container *ngIf="UIState === 'default' || UIState === 'countdown'">
              <button *ngIf="UI.recordButton" type="button" class="stage-btn stage-btn--record" (click)="startCountdown()">
                <span class="stage-btn__dot" aria-hidden="true"></span>
                RECORD
              </button>
              <button *ngIf="UI.practiceButton" type="button" class="stage-btn stage-btn--practice" (click)="play()">
                PRACTICE
              </button>
            </ng-container>

            <!-- recording: Stop -->
            <ng-container *ngIf="UIState === 'recording'">
              <button type="button" class="stage-btn stage-btn--stop" (click)="stopRecording()" ssTooltip="Stop the current recording session">
                <span class="stage-btn__square" aria-hidden="true"></span>
                STOP
              </button>
            </ng-container>

            <!-- practicing: Stop -->
            <ng-container *ngIf="UIState === 'practicing'">
              <button type="button" class="stage-btn stage-btn--stop" (click)="pause()" ssTooltip="Stop the current practice session">
                <span class="stage-btn__square" aria-hidden="true"></span>
                STOP
              </button>
            </ng-container>

            <!-- practicingPaused: Record + Resume + Restart -->
            <ng-container *ngIf="UIState === 'practicingPaused'">
              <button type="button" class="stage-btn stage-btn--record" (click)="startCountdown()" ssTooltip="Start recording immediately from the beginning of the song">
                <span class="stage-btn__dot" aria-hidden="true"></span>
                RECORD
              </button>
              <button type="button" class="stage-btn stage-btn--play" (click)="play()" ssTooltip="Play song">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                PLAY
              </button>
              <button type="button" class="stage-btn stage-btn--practice" (click)="restartPractice()" ssTooltip="Return to the beginning and get ready to practice or record again">RESTART</button>
            </ng-container>

            <!-- review: Try Again + Pause + Save -->
            <ng-container *ngIf="UIState === 'review'">
              <button type="button" class="stage-btn stage-btn--outline" (click)="tryAgain()" ssTooltip="Discard this recording and start over">TRY AGAIN</button>
              <button type="button" class="stage-btn stage-btn--play" (click)="pause()" ssTooltip="Play or pause your recorded performance">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                PAUSE
              </button>
              <button type="button" class="stage-btn stage-btn--save" (click)="upload()" ssTooltip="Save this recording">SAVE</button>
            </ng-container>

            <!-- reviewPaused: Try Again + Play + Save -->
            <ng-container *ngIf="UIState === 'reviewPaused'">
              <button type="button" class="stage-btn stage-btn--outline" (click)="tryAgain()" ssTooltip="Discard this recording and start over">TRY AGAIN</button>
              <button type="button" class="stage-btn stage-btn--play" (click)="play()" ssTooltip="Play or pause your recorded performance">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                PLAY
              </button>
              <button type="button" class="stage-btn stage-btn--save" (click)="upload()" ssTooltip="Save this recording">SAVE</button>
            </ng-container>

          </div>
          <!-- ── Scrub bar overlay ── -->
          <div class="video-scrubbar" *ngIf="loaded">
            <span class="video-scrubbar__time">{{ msToTime(playhead) }}</span>
            <app-progress-bar
              class="video-scrubbar__bar"
              [recorder]="true"
              [duration]="duration"
              [noSeek]="recorder?.recording"
              [current]="playhead"
              [inputTabIndex]="recorder?.recording ? -1 : 0"
              (seek)="seek($event)"
              (range)="changeRangeTime($event)"
            ></app-progress-bar>
            <span class="video-scrubbar__duration">{{ msToTime(duration) }}</span>
          </div>
        </div><!-- end #videoContainer -->
      </section>

    </div><!-- /shell__stage -->

    <!-- RIGHT panel: Visual Setup — hidden in review/playback mode -->
    <aside class="shell__panel shell__panel--right" [class.fs-open]="fsPanelRightOpen" *ngIf="loaded && !finished && UIState !== 'review' && UIState !== 'reviewPaused'">
      <button class="fs-panel-close" type="button" (click)="closeFsPanelRight()" aria-label="Close panel"
              [attr.tabindex]="(fullscreen && fsPanelRightOpen) ? null : -1">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <div class="panel">
        <div class="panel__header panel__header--static">
          <span class="panel__title">Visual Setup</span>
        </div>
        <div class="panel__body">

          <!-- Lighting section -->
          <div class="section">
            <h3 class="section__header">
              <span class="section__label">Screen Lighting</span>
              <span class="section__actions">
                <button type="button" class="section__reset"
                        [class.is-active]="stageMode"
                        (click)="toggleStageMode()"
                        ssTooltip="Stage Mode — dim chrome while recording so the camera stands out"
                        [attr.aria-pressed]="stageMode"
                        aria-label="Toggle Stage Mode">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                  </svg>
                </button>
                <button type="button" class="section__reset"
                        [class.is-active]="sunMode"
                        (click)="toggleSunMode()"
                        ssTooltip="Sun Mode — one-tap max bright white fill light"
                        [attr.aria-pressed]="sunMode"
                        aria-label="Toggle Sun Mode">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="12" r="5"/>
                    <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
                  </svg>
                </button>
                <button type="button" class="section__reset"
                        (click)="resetLighting()"
                        ssTooltip="Reset Brightness, Tone, and Contrast to defaults"
                        aria-label="Reset lighting controls">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="1 4 1 10 7 10"/>
                    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/>
                  </svg>
                </button>
              </span>
            </h3>
            <div class="section__body">
              <rec-fill-light show="brightness" (userBrightnessChange)="onUserBrightnessChange()"></rec-fill-light>
              <rec-fill-light show="tones"></rec-fill-light>

              <button type="button" class="lighting-more"
                      [class.is-open]="contrastExpanded"
                      [attr.aria-expanded]="contrastExpanded"
                      (click)="toggleContrastExpanded()"
                      ssTooltip="Show or hide the Contrast slider">
                <span>{{ contrastExpanded ? 'Less' : 'More' }}</span>
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>

              @if (contrastExpanded) {
                <div class="perf-slider" ssTooltip="Increase or decrease panel brightness relative to the background">
                  <div class="perf-slider__header">
                    <span class="perf-slider__label">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
                      CONTRAST
                    </span>
                    <span
                      *ngIf="editingPill !== 'contrast'"
                      class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                      role="button"
                      tabindex="0"
                      ssTooltip="Click to enter an exact value (0–100)"
                      (click)="startPillEdit('contrast', contrast)"
                      (keydown.enter)="startPillEdit('contrast', contrast)">{{ contrast }}</span>
                    <input
                      *ngIf="editingPill === 'contrast'"
                      #pillInput
                      type="number"
                      class="perf-slider__current perf-slider__current--input"
                      min="0" max="100" step="1"
                      aria-label="Panel contrast (0 to 100)"
                      [value]="pillDraft"
                      (blur)="commitPillEdit('contrast', $any($event.target).value, 0, 100)"
                      (keydown.enter)="commitPillEdit('contrast', $any($event.target).value, 0, 100)"
                      (keydown.escape)="cancelPillEdit()"
                    />
                  </div>
                  <input
                    type="range"
                    class="perf-slider__track"
                    min="0" max="100" step="1"
                    aria-label="Panel contrast"
                    [value]="contrast"
                    [style.background]="sliderBg(contrast, 0, 100)"
                    (input)="onContrastChange(+$any($event.target).value)"
                  />
                  <div class="perf-slider__marks">
                    <span>Low</span><span>Default</span><span>High</span>
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Lyrics section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Lyrics</span></h3>
            <div class="section__body">
              <div class="perf-slider" ssTooltip="Make the lyrics smaller or larger">
                <div class="perf-slider__header">
                  <span class="perf-slider__label">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>
                    LYRIC SIZE
                  </span>
                  <span
                    *ngIf="editingPill !== 'lyricSize'"
                    class="perf-slider__current perf-slider__current--pill perf-slider__current--editable"
                    role="button"
                    tabindex="0"
                    ssTooltip="Click to enter an exact value (0–6)"
                    (click)="startPillEdit('lyricSize', lyricSize)"
                    (keydown.enter)="startPillEdit('lyricSize', lyricSize)">{{ lyricSize }}</span>
                  <input
                    *ngIf="editingPill === 'lyricSize'"
                    #pillInput
                    type="number"
                    class="perf-slider__current perf-slider__current--input"
                    min="0" max="6" step="1"
                    aria-label="Lyric size (0 to 6)"
                    [value]="pillDraft"
                    (blur)="commitPillEdit('lyricSize', $any($event.target).value, 0, 6)"
                    (keydown.enter)="commitPillEdit('lyricSize', $any($event.target).value, 0, 6)"
                    (keydown.escape)="cancelPillEdit()"
                  />
                </div>
                <input
                  type="range"
                  class="perf-slider__track"
                  min="0" max="6" step="1"
                  aria-label="Lyric size"
                  [value]="lyricSize"
                  [style.background]="sliderBg(lyricSize, 0, 6)"
                  (input)="onLyricSizeChange(+$any($event.target).value)"
                />
                <div class="perf-slider__marks">
                  <span>0</span><span>3</span><span>6</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Theme section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Theme</span></h3>
            <div class="section__body">

              <div class="vis-sub" data-vis-grid="theme">
                <button #themesToggle type="button" class="vis-sub__toggle"
                        [attr.aria-expanded]="themesExpanded"
                        (click)="$event.stopPropagation(); toggleThemes()"
                        ssTooltip="Change the recorder colour theme">
                  <span class="vis-sub__toggle-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
                    </svg>
                    Theme
                  </span>
                  <span class="vis-sub__right">
                    <span class="vis-sub__selected-name" *ngIf="!themesExpanded">{{ themeService.activeTheme.name }}</span>
                    <svg class="vis-sub__chevron" [class.is-open]="themesExpanded" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>
                @if (themesExpanded) {
                  <rec-theme-picker (commit)="commitThemes()" (builderActive)="themeBuilderActive = $event"></rec-theme-picker>
                }
              </div>
            </div>
          </div>

          <!-- Presentation section: Filters + Frames — not in review/playback or audio-only mode -->
          <div class="section" *ngIf="recorder && UIState !== 'review' && UIState !== 'reviewPaused' && !recorder?.recorder?.noCam">
            <h3 class="section__header"><span class="section__label">Presentation</span></h3>
            <div class="section__body">

              <!-- FILTERS collapsible -->
              <div class="vis-sub" data-vis-grid="filter">
                <button #filtersToggle class="vis-sub__toggle" type="button"
                        [attr.aria-expanded]="filtersExpanded"
                        (click)="$event.stopPropagation(); toggleFilters()"
                        ssTooltip="Change the visual look of your recording">
                  <span class="vis-sub__toggle-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                    </svg>
                    Filters
                  </span>
                  <span class="vis-sub__right">
                    <span class="vis-sub__selected-name" *ngIf="!filtersExpanded">{{ filterName === 'none' ? 'None' : filterName }}</span>
                    <svg class="vis-sub__chevron" [class.is-open]="filtersExpanded" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>
                <div class="fx-grid" role="grid" aria-label="Filters"
                     *ngIf="filtersExpanded && recorder?.filters"
                     (keydown)="onFxGridKeydown($event, 'filter', recorder.filters.length)">
                  <button
                    *ngFor="let filter of recorder.filters; let i = index"
                    class="fx-thumb"
                    role="gridcell"
                    [class.fx-thumb--selected]="filterIndex === i"
                    [attr.tabindex]="filterFocusIndex === i ? 0 : -1"
                    [attr.aria-selected]="filterIndex === i"
                    type="button"
                    (click)="onFilterThumbChange(String(i))"
                    (dblclick)="onFilterThumbChange(String(i)); commitFilters()"
                  >
                    <div class="fx-thumb__img-wrap">
                      <img src="assets/images/video_fx_preview.jpeg" [style.filter]="filter.preview" [alt]="filter.name" />
                      <span class="fx-thumb__check" *ngIf="filterIndex === i" aria-hidden="true">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </span>
                    </div>
                    <span class="fx-thumb__name">{{ filter.name }}</span>
                  </button>
                </div>
              </div>

              <!-- FRAMES collapsible -->
              <div class="vis-sub" data-vis-grid="frame">
                <button #framesToggle class="vis-sub__toggle" type="button"
                        [attr.aria-expanded]="framesExpanded"
                        (click)="$event.stopPropagation(); toggleFrames()"
                        ssTooltip="Add a decorative frame to your recording">
                  <span class="vis-sub__toggle-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/>
                      <line x1="10" y1="3" x2="10" y2="21"/><line x1="16" y1="3" x2="16" y2="21"/>
                    </svg>
                    Frames
                  </span>
                  <span class="vis-sub__right">
                    <span class="vis-sub__selected-name" *ngIf="!framesExpanded">{{ currentFrameName }}</span>
                    <svg class="vis-sub__chevron" [class.is-open]="framesExpanded" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>
                <div class="fx-grid" role="grid" aria-label="Frames"
                     *ngIf="framesExpanded"
                     (keydown)="onFxGridKeydown($event, 'frame', framesPaths.length)">
                  <button
                    *ngFor="let frame of framesPaths; let i = index"
                    class="fx-thumb"
                    role="gridcell"
                    [class.fx-thumb--selected]="currentFrameName === frame.name"
                    [attr.tabindex]="frameFocusIndex === i ? 0 : -1"
                    [attr.aria-selected]="currentFrameName === frame.name"
                    type="button"
                    (click)="onFrameThumbChange(frame.name)"
                    (dblclick)="onFrameThumbChange(frame.name); commitFrames()"
                  >
                    <div class="fx-thumb__img-wrap">
                      <img src="assets/images/video_fx_preview.jpeg" alt="" />
                      <img
                        *ngIf="recorder?.frames?.[frame.name]?.src"
                        class="fx-thumb__frame-overlay"
                        [src]="recorder.frames[frame.name].src"
                        [alt]="frame.name"
                      />
                      <span class="fx-thumb__check" *ngIf="currentFrameName === frame.name" aria-hidden="true">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </span>
                    </div>
                    <span class="fx-thumb__name">{{ frame.name }}</span>
                  </button>
                </div>
              </div>

              <!-- EFFECTS collapsible — persistent full-frame overlay, single-select
                   like Filters/Frames. Bakes into the recording. -->
              <div class="vis-sub" data-vis-grid="effect">
                <button #effectsToggle class="vis-sub__toggle" type="button"
                        [attr.aria-expanded]="effectsExpanded"
                        (click)="$event.stopPropagation(); toggleEffectsExpanded()"
                        ssTooltip="Add a full-screen effect (vignette, colour wash, grain…) to your recording">
                  <span class="vis-sub__toggle-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 1 0 18z"/>
                    </svg>
                    Effects
                  </span>
                  <span class="vis-sub__right">
                    <span class="vis-sub__selected-name" *ngIf="!effectsExpanded">{{ selectedEffectName }}</span>
                    <svg class="vis-sub__chevron" [class.is-open]="effectsExpanded" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>
                <div class="fx-grid" role="grid" aria-label="Effects" *ngIf="effectsExpanded">
                  <button
                    *ngFor="let effect of videoEffects"
                    class="fx-thumb"
                    role="gridcell"
                    type="button"
                    [class.fx-thumb--selected]="selectedEffectId === effect.id"
                    [attr.aria-selected]="selectedEffectId === effect.id"
                    [ssTooltip]="effect.name"
                    (click)="selectEffect(effect.id)"
                  >
                    <div class="fx-thumb__img-wrap fx-thumb__img-wrap--effect" [style.background]="effect.preview">
                      <span class="fx-thumb__check" *ngIf="selectedEffectId === effect.id" aria-hidden="true">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </span>
                    </div>
                    <span class="fx-thumb__name">{{ effect.name }}</span>
                  </button>
                </div>
              </div>

              <!-- VIBES collapsible — same pattern as Filters/Frames, but each
                   thumb FIRES a burst onto the recording (no persistent selection). -->
              <div class="vis-sub" data-vis-grid="vibe">
                <button #vibesToggle class="vis-sub__toggle" type="button"
                        [attr.aria-expanded]="vibesExpanded"
                        (click)="$event.stopPropagation(); toggleVibesExpanded()"
                        ssTooltip="Tap a vibe to fire an animated burst onto your recording">
                  <span class="vis-sub__toggle-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z"/>
                    </svg>
                    Vibes
                  </span>
                  <span class="vis-sub__right">
                    <svg class="vis-sub__chevron" [class.is-open]="vibesExpanded" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
                      <polyline points="6 9 12 15 18 9"/>
                    </svg>
                  </span>
                </button>
                <div class="fx-grid" role="grid" aria-label="Vibes" *ngIf="vibesExpanded">
                  <button
                    *ngFor="let vibe of vibes"
                    class="fx-thumb vibes-thumb"
                    role="gridcell"
                    type="button"
                    [ssTooltip]="vibe.name"
                    [attr.aria-label]="'Fire ' + vibe.name + ' vibe'"
                    (click)="fireVibe(vibe)"
                  >
                    <div class="fx-thumb__img-wrap fx-thumb__img-wrap--vibe">
                      <svg class="vibes-thumb__icon" width="30" height="30" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path [attr.d]="vibe.iconPath"></path>
                      </svg>
                    </div>
                    <span class="fx-thumb__name">{{ vibe.name }}</span>
                  </button>
                </div>
                <!-- Show/hide the moveable Vibes box (draggable over the video). -->
                <button *ngIf="vibesExpanded"
                        type="button"
                        class="mmsb-toggle vibes-boxtoggle"
                        [class.is-on]="vibesBoxOpen"
                        [attr.aria-pressed]="vibesBoxOpen"
                        (click)="toggleVibesBox()"
                        ssTooltip="Show a moveable Vibes box over the video that you can drag anywhere">
                  <span class="mmsb-toggle__icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <polyline points="5 9 2 12 5 15"/><polyline points="9 5 12 2 15 5"/><polyline points="15 19 12 22 9 19"/><polyline points="19 9 22 12 19 15"/><line x1="2" y1="12" x2="22" y2="12"/><line x1="12" y1="2" x2="12" y2="22"/>
                    </svg>
                  </span>
                  <span class="mmsb-toggle__text">Moveable box</span>
                  <span class="mmsb-toggle__badge" [class.is-on]="vibesBoxOpen">{{ vibesBoxOpen ? 'ON' : 'OFF' }}</span>
                </button>
              </div>

            </div>
          </div><!-- /Presentation section -->

        </div><!-- /panel__body -->
      </div><!-- /panel -->
    </aside><!-- /right panel -->

    <!-- ── Review-state RIGHT panel: Lighting + Lyrics ── -->
    <aside class="shell__panel shell__panel--right" [class.fs-open]="fsPanelRightOpen" *ngIf="loaded && (UIState === 'review' || UIState === 'reviewPaused')">
      <button class="fs-panel-close" type="button" (click)="closeFsPanelRight()" aria-label="Close panel"
              [attr.tabindex]="(fullscreen && fsPanelRightOpen) ? null : -1">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <div class="panel">
        <div class="panel__header panel__header--static">
          <span class="panel__title">Visual</span>
        </div>
        <div class="panel__body">

          <!-- LIGHTING section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Screen Lighting</span></h3>
            <div class="section__body">
              <rec-fill-light show="brightness"></rec-fill-light>
            </div>
          </div>

          <!-- LYRICS section -->
          <div class="section">
            <h3 class="section__header"><span class="section__label">Lyrics</span></h3>
            <div class="section__body">

              <!-- Lyrics On/Off toggle -->
              <button
                type="button"
                class="mmsb-toggle"
                [class.is-on]="lyricsVisible"
                [attr.aria-pressed]="lyricsVisible"
                ssTooltip="Show or hide the karaoke lyrics during playback"
                (click)="toggleLyrics()"
              >
                <span class="mmsb-toggle__icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="8" y1="13" x2="16" y2="13"/>
                    <line x1="8" y1="17" x2="13" y2="17"/>
                  </svg>
                </span>
                <span class="mmsb-toggle__text">Lyrics</span>
                <span class="mmsb-toggle__badge" [class.is-on]="lyricsVisible">{{ lyricsVisible ? 'ON' : 'OFF' }}</span>
              </button>

            </div>
          </div>

          <!-- Still not right? → Bugsnag report -->
          <div class="section">
            <div class="section__body">
              <button
                *ngIf="!reportOpen && !reportSent"
                type="button"
                class="report-link"
                (click)="openReport()">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 9v4"/><path d="M12 17h.01"/><circle cx="12" cy="12" r="10"/></svg>
                Send diagnostics to SingSnap
              </button>

              <div *ngIf="reportOpen" class="report-box">
                <textarea
                  class="report-box__note"
                  rows="2"
                  maxlength="500"
                  aria-label="Describe the issue or ticket number (required)"
                  placeholder="Describe the issue or your ticket # (required)"
                  [value]="reportNote"
                  (input)="reportNote = $any($event.target).value"></textarea>
                <p class="report-box__hint">Use this only if SingSnap support asked for your recorder diagnostics. Add the issue (or your ticket number), then <b>Send to SingSnap</b>. These details go to us as a message. (Copy is a fallback if the send fails.)</p>
                <pre class="report-box__info" aria-label="Setup details">{{ reportSetup }}</pre>
                <p *ngIf="reportError" class="report-box__error">Couldn't send the message — please <b>Copy</b> the details and email them to support&#64;singsnap.com.</p>
                <div class="report-box__actions">
                  <button type="button" class="report-box__btn report-box__btn--ghost" (click)="cancelReport()">Close</button>
                  <button type="button" class="report-box__btn report-box__btn--copy" [disabled]="!reportNote?.trim()" (click)="copyReport()">{{ reportCopied ? 'Copied!' : 'Copy' }}</button>
                  <button type="button" class="report-box__btn report-box__btn--go" [disabled]="!reportNote?.trim() || reportSending" (click)="sendToSupport()">{{ reportSending ? 'Sending…' : 'Send to SingSnap' }}</button>
                </div>
              </div>

              <p *ngIf="reportSent" class="report-thanks">Sent to SingSnap — thanks!</p>
            </div>
          </div>

        </div><!-- /panel__body -->
      </div><!-- /panel -->
    </aside><!-- /review right panel -->

  </div><!-- /shell__grid -->

  <!-- ── Footer action bar ── -->
  <footer class="shell__footer" id="bottomUI" #bottomUI *ngIf="loaded">

    <!-- Default: Record + Practice -->
    <div class="stage-actions" *ngIf="(UI.recordButton || UI.practiceButton) && UIState !== 'practicingPaused'">
      <button
        *ngIf="UI.recordButton"
        type="button"
        class="stage-btn stage-btn--record"
        (click)="startCountdown()"
        ssTooltip="Start recording from the beginning of the song"
      >
        <span class="stage-btn__dot" aria-hidden="true"></span>
        RECORD
      </button>
      <button
        *ngIf="UI.resumePracticeButton"
        type="button"
        class="stage-btn stage-btn--play-circle"
        (click)="play()"
        aria-label="Resume practice"
        ssTooltip="Play or pause your recorded performance"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
      </button>
      <button
        *ngIf="UI.practiceButton"
        type="button"
        class="stage-btn stage-btn--practice"
        (click)="play()"
        ssTooltip="Rehearse the song without recording"
      >
        PRACTICE
      </button>
    </div>

    <!-- Recording: Stop -->
    <div class="stage-actions" *ngIf="UI.stopRecordingButton">
      <button type="button" class="stage-btn stage-btn--stop" (click)="stopRecording()" ssTooltip="Stop the current recording session">
        <span class="stage-btn__square" aria-hidden="true"></span>
        STOP
      </button>
    </div>

    <!-- Practicing: Stop -->
    <div class="stage-actions" *ngIf="UIState === 'practicing'">
      <button type="button" class="stage-btn stage-btn--stop" (click)="pause()" ssTooltip="Stop the current practice session">
        <span class="stage-btn__square" aria-hidden="true"></span>
        STOP
      </button>
    </div>

    <!-- PracticingPaused: Record + Resume + Restart -->
    <div class="stage-actions" *ngIf="UIState === 'practicingPaused'">
      <button type="button" class="stage-btn stage-btn--record" (click)="startCountdown()" ssTooltip="Start recording immediately from the beginning of the song">
        <span class="stage-btn__dot" aria-hidden="true"></span>
        RECORD
      </button>
      <button type="button" class="stage-btn stage-btn--play" (click)="play()" ssTooltip="Play song">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        PLAY
      </button>
      <button type="button" class="stage-btn stage-btn--practice" (click)="restartPractice()" ssTooltip="Return to the beginning and get ready to practice or record again">RESTART</button>
    </div>

    <!-- Review: Try Again + Play/Pause + Save -->
    <div class="stage-actions stage-actions--review" *ngIf="UI.saveOrTryAgainButtons">
      <button type="button" class="stage-btn stage-btn--outline" (click)="tryAgain()" ssTooltip="Discard this recording and start over">
        TRY AGAIN
      </button>
      <button
        *ngIf="UI.pauseButton"
        type="button"
        class="stage-btn stage-btn--play"
        (click)="pause()"
        ssTooltip="Play or pause your recorded performance"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
        PAUSE
      </button>
      <button
        *ngIf="UI.resumePracticeButton"
        type="button"
        class="stage-btn stage-btn--play"
        (click)="play()"
        ssTooltip="Play or pause your recorded performance"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"/></svg>
        PLAY
      </button>
      <button type="button" class="stage-btn stage-btn--save" (click)="upload()" ssTooltip="Save this recording">
        SAVE
      </button>
    </div>

  </footer>

  <app-other-singers #otherSingers></app-other-singers>

  <app-sync-test-modal
    *ngIf="showSyncModal"
    [currentSync]="sync"
    (syncApplied)="onSyncModalApplied($event)"
    (closed)="onSyncModalClosed()"
  ></app-sync-test-modal>

  <!-- ── Moveable Vibes box — draggable panel of vibe buttons over the recorder.
       Drag via the handle; tap a chip to fire. Show/hide from the Presentation
       panel or the box's close button. Camera-on only; chrome, never recorded. -->
  <div class="vibes-box"
       [class.vibes-box--vertical]="vibesBoxVertical"
       *ngIf="vibesBoxOpen && loaded && cam && !finished"
       [style.left.%]="vibesBoxX"
       [style.top.%]="vibesBoxY"
       [style.opacity]="vibesBoxOpacity">
    <div class="vibes-box__handle"
         (pointerdown)="onBoxDown($event)"
         (pointermove)="onBoxMove($event)"
         (pointerup)="onBoxUp($event)"
         (pointercancel)="onBoxUp($event)"
         ssTooltip="Drag to move the Vibes box">
      <svg class="vibes-box__grip" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <circle cx="8" cy="6" r="1.5"/><circle cx="8" cy="12" r="1.5"/><circle cx="8" cy="18" r="1.5"/>
        <circle cx="16" cy="6" r="1.5"/><circle cx="16" cy="12" r="1.5"/><circle cx="16" cy="18" r="1.5"/>
      </svg>
      <span class="vibes-box__title" *ngIf="!vibesBoxVertical">Vibes</span>
      <button type="button" class="vibes-box__orient"
              (pointerdown)="$event.stopPropagation()"
              (click)="toggleVibesBoxOrient()"
              [attr.aria-pressed]="vibesBoxVertical"
              aria-label="Switch box layout"
              ssTooltip="Switch between horizontal and vertical layout">
        <svg *ngIf="!vibesBoxVertical" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <rect x="3" y="10" width="18" height="4" rx="1"/>
        </svg>
        <svg *ngIf="vibesBoxVertical" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <rect x="10" y="3" width="4" height="18" rx="1"/>
        </svg>
      </button>
      <input
        *ngIf="!vibesBoxVertical"
        type="range"
        class="vibes-box__opacity"
        min="0.2" max="1" step="0.05"
        [value]="vibesBoxOpacity"
        (pointerdown)="$event.stopPropagation()"
        (input)="onBoxOpacity(+$any($event.target).value)"
        aria-label="Vibes box transparency"
        ssTooltip="Make the box more or less transparent" />
      <button type="button" class="vibes-box__close" (pointerdown)="$event.stopPropagation()" (click)="toggleVibesBox()" aria-label="Hide vibes box" ssTooltip="Hide the Vibes box">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="vibes-box__chips">
      <ng-container *ngFor="let g of vibeGroups; let last = last">
        <button
          *ngFor="let vibe of g.vibes"
          type="button"
          class="vibes-chip"
          (click)="fireVibe(vibe)"
          [ssTooltip]="vibe.name"
          [attr.aria-label]="'Fire ' + vibe.name + ' vibe'">
          <svg class="vibes-chip__icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path [attr.d]="vibe.iconPath"></path>
          </svg>
        </button>
        <span class="vibes-box__divider" *ngIf="!last" aria-hidden="true"></span>
      </ng-container>
    </div>
  </div>

</main>
